import { projectRequest } from 'store/utils/request';

const TIMEOUT_DURATION = 10 * 60 * 1000;

export const getXpacksRequest = async params => {
  try {
    return await projectRequest.get(`/xpacks/`, {
      params,
    });
  } catch (error) {
    throw error;
  }
};

export const addXpackRequest = async file => {
  try {
    const data = new FormData();
    data.append('nlu_file', file, file.name);

    return await projectRequest.post(`/xpacks/`, data, {
      headers: {
        'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
      },
      requestId: 'add-xpack',
      timeout: TIMEOUT_DURATION,
    });
  } catch (error) {
    throw error;
  }
};

/* eslint-disable-next-line camelcase */
export const updateXpackRequest = async (xpackId, { nlu_file }) => {
  try {
    const data = new FormData();
    data.append('nlu_file', nlu_file, nlu_file.name);

    const requestConfig = {
      headers: {
        'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
      },
      requestId: 'update-xpack',
      timeout: TIMEOUT_DURATION,
    };

    return await projectRequest.put(`/xpacks/${xpackId}/`, data, requestConfig);
  } catch (error) {
    throw error;
  }
};

export const overrideAllXpackIntentsRequest = xpackId =>
  projectRequest.post(`/xpacks/${xpackId}/override_all_intents/`);

export const disableAllXpackIntentsRequest = xpackId =>
  projectRequest.post(`/xpacks/${xpackId}/enable_all_intents/`);

export const deleteXpackRequest = async xpackId => {
  try {
    return await projectRequest.delete(`/xpacks/${xpackId}/`, {
      timeout: TIMEOUT_DURATION,
    });
  } catch (error) {
    throw error;
  }
};

export const downloadXpackRequest = async xpackId => {
  try {
    return await projectRequest.get(`/xpacks/${xpackId}/download/`, {
      responseType: 'blob',
      timeout: TIMEOUT_DURATION,
    });
  } catch (error) {
    throw error;
  }
};
